import { render, staticRenderFns } from "./orderCustomerField.vue?vue&type=template&id=3062c01b&scoped=true"
import script from "./orderCustomerField.vue?vue&type=script&lang=js"
export * from "./orderCustomerField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3062c01b",
  null
  
)

export default component.exports